<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span>
      Consistente
    </div>

    <div class="subtitle-item">
      <input type="checkbox" v-model="reds" @change="onChangeReds($event)" />
      <span class="red"></span>
      Inconsistente

      <span
        v-b-tooltip.hover
        title="Verificar no detalhamento do estabelecimento a inconsistência e o que deve ser feito para resolver."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  data() {
    return {
      greens: false,
      reds: false,
    }
  },
  methods: {
    /**
     * Manipula a exibição dos registros consistentes.
     *
     * @param {Event} event Evento de alteração do checkbox
     */
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },

    /**
     * Manipula a exibição dos registros inconsistentes.
     *
     * @param {Event} event Evento de alteração do checkbox
     */
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
  },
}
</script>

<style></style>
